import { AxiosResponse } from 'axios'
import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'
import InventoryBundlesDao from '@/interfaces/inventory/InventoryBundles.dao'
import InventoryBundleDao from '@/interfaces/inventory/InventoryBundle.dao'
import InventoryBundleDto from '@/interfaces/inventory/InventoryBundle.dto'
import InventoryBundlesLookupsDao from '@/interfaces/inventory/InventoryBundlesLookups.dao'
import InventoryBundleChannelProfileStockDao from '@/interfaces/inventory/InventoryBundleChannelProfileStock.dao'

export default class InventoryService extends ApiService {
    async getInventoryBundles(
        params?: IRequestParameters,
    ): Promise<[InventoryBundlesDao[], PageNumberPagination] | null> {
        return this.request<undefined, [InventoryBundlesDao[], PageNumberPagination]>(
            'GET',
            '/inventory-bundles',
            params,
        ).catch(() => null)
    }
    async getInventoryBundle(id: string): Promise<InventoryBundleDao | null> {
        return this.request<undefined, InventoryBundleDao>('GET', `/inventory-bundles/${id}`).catch(() => null)
    }

    async getInventoryBundleChannelProfileStock(id: string): Promise<InventoryBundleChannelProfileStockDao[] | null> {
        return this.request<undefined, InventoryBundleChannelProfileStockDao[]>(
            'GET',
            `/inventory-bundles/${id}/channel-profile-stock`,
            undefined,
            undefined,
            undefined,
            'getInventoryBundleChannelProfileStock',
        ).catch(() => null)
    }

    async getInventoryBundlesLookups(): Promise<InventoryBundlesLookupsDao | null> {
        return this.request<undefined, InventoryBundlesLookupsDao>(
            'GET',
            '/inventory-bundles/lookups',
            undefined,
            undefined,
            undefined,
            'getInventoryBundlesLookups',
        ).catch(() => null)
    }

    async exportInventoryBundles(params: IRequestParameters): Promise<AxiosResponse | null> {
        return this.request<undefined, AxiosResponse>(
            'GET',
            '/inventory-bundles/export',
            params,
            undefined,
            'blob',
            'exportInventoryBundles',
        ).catch(() => null)
    }

    async updateInventoryBundle(inventoryBundleDto: InventoryBundleDto): Promise<InventoryBundleDao | null> {
        return this.request<InventoryBundleDto, InventoryBundleDao>(
            'PUT',
            `/inventory-bundles`,
            undefined,
            inventoryBundleDto,
            undefined,
            'updateInventoryBundle',
        ).catch(() => null)
    }
}
